var EMBEDDED_LOCATIONS_CSV = "Business/Org Name,Primary Category,Subcategories (comma-separated),Address,Description,Website,Phone,Latitude,Longitude,Updated By,Updated At\r\nAgrace Thrift Store: Janesville,Secondhand,\"Furniture, Home Decor, Clothing, Housewares, Collectible, Books\",\"2043 Humes Rd, Janesville, WI 53545\",\"Donation and secondhand shop. Furniture, home décor, Clothing, Housewares, collectibles, books or gifts. (9/2025)\",https://www.agrace.org/thriftstore/,(608) 314-2990,42.722066,-88.997092\r\nAgrace Thrift Store: Madison- Home Store,Secondhand,\"Furniture, Home Decor, Clothing, Housewares, Collectible, Books\",\"1946 S Stoughton Rd, Madison, WI 53716\",\"Donation and secondhand shop. Furniture, home décor, Clothing, Housewares, collectibles, books or gifts. (9/2025)\",https://www.agrace.org/thriftstore/,(608) 327-7396,43.07019,-89.310503\r\nAgrace Thrift Store: Madison-East,Secondhand,\"Furniture, Home Decor, Clothing, Housewares, Collectible, Books\",\"2402 E Springs Dr, Madison, WI 53704\",\"Donation and secondhand shop. Furniture, home décor, Clothing, Housewares, collectibles, books or gifts. (9/2025)\",https://www.agrace.org/thriftstore/,(608) 327-7200,43.130139,-89.296314\r\nAgrace Thrift Store: Madison-West,Secondhand,\"Furniture, Home Decor, Clothing, Housewares, Collectible, Books\",\"118 Junction Rd, Madison, WI 53717\",\"Donation and secondhand shop. Furniture, home décor, Clothing, Housewares, collectibles, books or gifts. (9/2025)\",https://www.agrace.org/thriftstore/,(608) 327-7072,43.061657,-89.52796\r\nAgrace Thrift Store: Pack Up Pick Up,Secondhand,Furniture,Dane & Rock Counties,\"Agrace offers a free way to donate used furniture and home goods. The trained team will come to your home, pack your donations, and deliver them to one of their stores (9/2025)\",https://www.agrace.org/thriftstore/,(608) 640-0139,42.752257,-88.778766\r\nBadger Electronics & ITAD,Hard-To-Recycle,Electronics,\"Stoughton, WI\",Free and paid electronic waste pickup services that can be scheduled regularly or as needed. This includes organizing e-waste collection drives for those interested. ,https://madisonrecycling.com/,(608) 239-8007,42.916762,-89.220406\r\nBHA Resale Store Unlimited,Secondhand,\"Furniture, Home Decor, Housewares, Collectible, Books\",\"3365 E Washington Ave, Madison, WI 53704\",\"Consignment, donation, and secondhand store featuring furniture, antiques, tools, books, household items, and more. \",https://www.facebook.com/Resalestoreunlimited/,(608) 298-7707,43.112007,-89.331359\r\nBoomerangs Resale Store,Secondhand,\"Clothing, Furniture, Home Decor\",\"1133 N Sherman Ave, Madison, WI 53704\",\"Secondhand store on Madison's North side featuring clothing, furniture, home items and more.\",https://boomerangsresale.org/,(608) 268-0793,43.112853,-89.362614\r\nCapitol View Farmer's Market,Farmer's Market,Grocery,\"5901 Sharpsburg Dr, Madison, WI 53718\",Wednesdays June through October 3:00 pm - 7:00 pm,https://capitolviewfarmersmarket.com/,,43.1365,-89.2294\r\nCecil's Shoe Repair,Repair,Shoes,\"6717 Odana Road Madison, WI 53719\",Local shoe repair store with limited hours. Recommend calling ahead to verify open hours and availability. (9/2025),,(608) 833-5010,43.056015,-89.498274\r\nCommunity Pharmacy East-Side,Bulk/Package-Free,Tea & Herbs,\"130 S Fair Oaks Ave, Madison, WI 53704\",Local pharmacy providing a large selection of bulk herbs and teas available for purchase by the ounce. (Listing Verified 9/2025),https://www.communitypharmacy.coop/,(608) 251-3242,43.096764,-89.337316\r\nCommunity Pharmacy Wellness Shop,Bulk/Package-Free,Tea & Herbs ,\"6333 University Ave, Middleton, WI 53562\",Local pharmacy providing a large selection of bulk herbs and teas available for purchase by the ounce. (Listing Verified 9/2025),https://www.communitypharmacy.coop/,(608) 310-5390,43.092602,-89.491402\r\nCool Bikes North,Hard-To-Recycle,Housewares,\"1861 Northport Dr, Madison, WI 53704\",Your smelly-tasting bike water bottle will get turned into construction materials. Also a bike shop,https://www.coolbikesnorth.com/,(608) 230-6717,43.12903754,-89.36006228\r\nDane County Farmer's Market,Farmer's Market,Grocery,\"200 Block Martin Luther King Junior Blvd, Madison, WI\",\"Wednesdays April through November, exact start and end date on website, 8:30 am to 1:45 pm\",https://dcfm.org/markets/wednesday-market,,43.072858,-89.381824\r\nDane County Farmer's Market,Farmer's Market,Grocery,Capitol Square,\"Saturdays April through November, exact start and end date on website, 6:15 am to 1:45 pm\",https://dcfm.org/markets/saturday-on-the-square,,43.0158602,-89.4247801\r\nDane County Farmers' Market [Holiday],Farmer's Market,Grocery,\"1 John Nolen Drive, Madison, WI 53703\",\"Holiday Market - Monona Terrace Community and Convention Center; Saturdays November through December, exact start and end date on website, 7:30 am - 12 pm\",https://dcfm.org/markets/holiday-market,,43.075729,-89.37587\r\nDane County Farmers' Market [Late Winter],Farmer's Market,Grocery,\"3241 Garver Green, Madison, WI 53704\",\"Late Winter Market - Garver Feed Mill; Saturdays January through April, exact start and end date on website, 8 am - 12 pm\",https://dcfm.org/markets/late-winter-market,,43.0945392,-89.3343968\r\nEastside Farmer's Market,Farmer's Market,Grocery,\"McPike Park, 202 S. Ingersoll St, Madison, WI 53703\",\"Tuesdays from April through November, exact start and end date on website, 4 pm to 7 pm\",https://www.eastsidefarmersmarket.org/,,43.082678,-89.368097\r\nEmma Mends Knits ,Repair,Clothing,1334 Williamson St. Madison WI 53703,\"Knit repair service specializing in extending the life of knits, crocheted and woven clothing and textiles to help reduce textile waste by restoring beloved garments. Offers drop-off service at Green Life Trading Co. (8/2025)\",https://greenlifetradingco.com/pages/knit-repair,,43.08507,-89.362144\r\nFitchburg Farmer's Market,Farmer's Market,Grocery,\"5511 East Cheryl Parkway, Fitchburg WI 53711\",\"Thursdays from May through October, exact start and end date on website, 3:00 pm to 7:00 pm\",https://fitchburgmarket.wordpress.com/,(608) 277-2592,43.002316,-89.424095\r\nGoodwill Fitchburg,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"6291 McKee Rd, Fitchburg, WI 53719\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/locations/goodwill-fitchburg/,(608) 268-5160,43.015117,-89.4802215\r\nGoodwill Madison East Towne,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"2127 East Springs Drive, Madison, WI 53704\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/locations/east-towne/,(608) 246-3147,43.1271798,-89.2925301\r\nGoodwill Madison Northside,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"2901 North Sherman Ave, Madison, WI 53704\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/locations/northside/,(608) 819-8082,43.1280148,-89.3612105\r\nGoodwill Madison West,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"7475 Mineral Point Rd, Madison, WI 53717\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/shop/find-a-store/ ,(608) 204-7450,43.0583065,-89.5123193\r\nGoodwill Middleton,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"6280 Century Ave, Middleton, WI 53562\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/locations/middleton/,(608) 820-1114,43.1046082,-89.4890334\r\nGoodwill Monona,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"2501 Royal Ave, Monona WI 53713\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/locations/monona/,(608) 224-0781,43.0418261,-89.3533936\r\nGoodwill Nakoma,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"4530 Verona Rd, Madison, WI 53711\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/locations/nakoma/,(608) 271-4687,43.0379585,-89.4570816\r\nGoodwill Sun Prairie,Secondhand,\"Clothing, Furniture, Home Decor, Housewares\",\"2111 McCoy Rd, Sun Prairie WI 53590\",\"Long-standing nonprofit chain with a range of pre-owned clothing, Housewares & more. Takes donations on site. (10/2025)\",https://goodwillscwi.org/locations/sun-prairie/,(608) 318-5560,43.1748083,-89.2491734\r\nGreen Box Compost,Compost,Compost Pickup Service,\"325 Linnerud Dr, Sun Prairie, WI 53590\",\"Compost pickup for homes, businesses, and apartments in the greater Madison area including Monona, Fitchburg, Middleton, Verona, Stoughton, Mount Horeb, Waunakee, and Sun Prairie. Green Box also offers a Compost Drop Off Membership at Green Life Trading Co. Visit greenlifetradingco.com/pages/services for more information. (Listing Verified 8/2025)\",https://www.withgreenbox.com/,(608) 888-9033,43.177,-89.217428\r\nGreen Life Trading Co.,Bulk/Package-Free,\"Tea & Herbs, Cleaning Supplies, Personal Care\",1334 Williamson St. Madison WI 53703,\"Refillery selling bulk home cleaning and personal care products. Green Life Trading Co. also offers a Compost Drop Off Membership program, Knit Repair Service and accepts donations of gently used tote bags, glass and metal containers. Visit greenlifetradingco.com/pages/services for more information.\",https://greenlifetradingco.com/,(608) 443-6331,43.08507,-89.362144\r\nHabitat ReStore - East,Secondhand,\"Furniture, Home Decor, Construction Supplies\",\"4207 Monona Dr, Madison, WI 53716\",\"Secondhand store, owned and operated by Habitat for Humanity of Dane County.  Find appliances, cabinets, furniture, flooring and finishes, lumber, plumbing and electrical supplies, tools, windows, and doors.\",https://habitatdane.org/restore/,(608) 661-2813,43.075123,-89.326646\r\nHabitat ReStore - West,Secondhand,\"Furniture, Home Decor, Construction Supplies\",\"6201 Odana Rd, Madison, WI 53719\",\"Secondhand store, owned and operated by Habitat for Humanity of Dane County.  Find appliances, cabinets, furniture, flooring and finishes, lumber, plumbing and electrical supplies, tools, windows, and doors.\",https://habitatdane.org/restore/,(608) 442-9919,43.052979,-89.487366\r\nHello Art Hatchery,Secondhand,\"Art Supplies, Home Decor\",\"134 East Main Street, Stoughton, Wisconsin 53589\",\"Hello Art Hatchery is Madison's first Creative Reuse Center! We accept clean, reusable art and craft materials from individuals and businesses and keep them out of the landfill by selling them online. Our art supplies are affordable, unique, and often vintage. Our inventory is ever changing! \",https://helloarthatchery.com/,(608) 205-9549,42.9168392,-89.2199071\r\nHilldale Farmers' Market,Farmer's Market,Grocery,\"702 N Midvale Blvd, Madison, WI 53705\",\"Located behind L.L. Bean, off of Segoe Road; Wednesdays & Saturdays May through October, exact start and end date on website, 8 am - 1 pm\",https://hilldale.com/about/farmers-market/,,43.0716319,-89.4546759,mannimal09,2026-08-19T01:23:55.439Z\r\nMachinery Row Bicycles,Repair,Bicycles,\"601 Williamson Street Madison, WI 53703\",Locally owned bike shop offering in store repairs as well as supplies for home repair/upkeep. Facilitate a bike trade in program for store credit and also provide bike rental program. (9/2025),https://www.machineryrowbicycles.com/,(608) 442-5974,43.075922,-89.375047\r\nMadison Greenhouse Store,Bulk/Package-Free,Garden,\"1354 Williamson Street, Madison, WI 53703   \",Madison Greenhouse Store sells package-free soil.,https://www.madisongreenhousestore.com/,(608) 819-8822,43.0852884,-89.3617591\r\nMadison Tool Library,Repair,Tool Share,\"56 Corry St, Madison, WI 53704\",\"Madison Tool Library - providing low cost tool and equipment rentals to Madison, WI residents and neighbors.  If there's something you'd like to rent we might have it, even if it's not listed!  Send us an e-mail.\",https://www.madisontoollibrary.org,,43.0982646,-89.3455716\r\nMonroe Street Farmers' Market,Farmer's Market,Grocery,\"2219 Monroe St, Madison, WI 53711\",\"Sundays May through October, exact start and end date on website, 9 am - 1 pm\",https://monroestreetfarmersmarket.org/,,43.06184,-89.42153\r\nMonroe Street Shoe Repair,Repair,Shoes,\"2630 Monroe Street Madison, WI 53711\",\"Locally owned shoe repair store. Services provided include Birkenstock repair, orthopedics, heel and sole replacements, stretching. Also provide purse repair, zipper replacement, shortening of belts/straps. Inquire with business for specific repairs. (9/2025)\",https://www.monroestreetshoerepair.com/,(608) 238-3171,43.0574722,-89.4287228\r\nMotorless Motion (MoMo) Bicycles,Repair,Bicycles,\"640 W Washington Ave, Madison, WI 53703\",Locally owned bike shop offering in store repairs as well as supplies for home repair/upkeep. Also offers bike rentals on a daily or weekly basis.,https://www.motorlessmotionbicycles.com/,(608) 443-0640,43.0680526,-89.393721\r\nOld Town Cycles,Repair,Bicycles,\"920 E Johnson St, Madison, WI 53703\",Locally owned bike shop offering in store repairs as well as supplies for home repair/upkeep.,https://www.oldtowncycles.com/,(608) 259-8696,43.0849631,-89.3756643\r\nSaffi Saana,Bulk/Package-Free,Grocery,\"5014 Voges Road Madison, WI 53718\",\"Local online store offering high-quality oils and vinegars in bulk and recovered wine bottles, which you can buy on their website or at the Willy St. Co-op locations. Saffi Saana accepts donations of wine bottles for their zero waste line and takes back their 5 Liter Bag in Box Bag.\",https://www.saffisaana.com/,,43.040631,-89.294783\r\nSector67,Repair,\"Tool Share, Coworking Space \",\"56 Corry St, Madison, WI 53704\",Community Workspace/Hackerspace/Makerspace/Collaborative Environment providing members/non members the opportunity to work with tools/tech.,https://www.sector67.org/blog/,(608) 241-4605,43.0982505,-89.3455905\r\nSharp On Sight,Repair,Knife Sharpening,\"215 E Main St, Sun Prairie, WI 53590\",\"Sharp On Sight’s sharpening services in Sun Prairie, WI. Offering knife, scissor, shear, clipper, grooming blade, and lawn tool sharpening, plus the drop-off process, live locations, and reliable service in the Madison Metro and Dane County.\",https://sharponsight.com/,(608) 695-3980,43.182926,-89.212196\r\nSt. Vincent de Paul Dig and Save Outlet,Secondhand,\"Clothing, Furniture, Home Decor, Clothing, Housewares, Accessories\",\"1900 South Park Street, Madison, WI 53713\",\"Dig through bins of items and come away with major savings! Most goods (including clothing, linens, home goods. etc.) sold by the pound. Features drive through donation center on site.\",https://svdpmadison.org/store/dig-save-store/,(608) 278-2920,43.044678,-89.395081\r\nTextile Arts Center of Madison,Repair,\"Clothing, Coworking Space\",\"1702 South Park Street, Madison, Wisconsin 53713\",\"Textile Arts Center of Madison is a center for creative reuse, accepting donations of fiber and textile art supplies and equipment, and making them available to the community. Sales of secondhand supplies will be two to three times annually.\",https://www.textileartsmadison.org/supplies,,43.0486167,-89.3941354\r\nThe Bodgery,Repair,\"Tool Share, Coworking Space\",\"740 Oscar Avenue, Madison, WI 53704\",Makerspace/hackerspace which provides access to tools/craft supplies. Memberships allow 24/7 access to the space.,https://www.thebodgery.org/,(862) 263-4363,43.1095277,-89.3553473\r\nThe Cozy Home - East,Secondhand,Furniture,\"6330 Monona Drive, Monona, WI 53716\",The Cozy Home is a quality furniture consignment store owned and run by the dynamic mother-daughter duo La Rae Richard and Leah Hernandez. *consignment is only available at East*,https://thecozyhomemadison.com/,(608) 286-1119,43.048861,-89.324318\r\nThe Cozy Home - West,Secondhand,Furniture,\"6801 University Avenue, Suite 140, Middleton, WI 53562\",The Cozy Home is a quality furniture consignment store owned and run by the dynamic mother-daughter duo La Rae Richard and Leah Hernandez. *consignment is not available at West*,https://thecozyhomemadison.com/ ,(608) 286-1119,43.096765,-89.499158\r\nThe Diamond Center,Repair,Jewelry,\"509 South Gammon RD. Madison, Wi 53719\",The Diamond Center is a family-owned jewelry store serving Madison and Janesville. Offers jewelry and watch repairs.,https://www.thediamondcenter.com/,(608) 833-3377,43.0562693,-89.5028022\r\nThe Electric Needle,Repair,Electronic,\"4281 W Beltline Highway, Madison, WI 53711\",The Electric Needle is a locally-owned small business which does sewing machine repair.  They are able to work on many makes of domestic sewing machines and sergers.  No appointment necessary. Also carry many supplies for mending.,https://www.electric-needle.com/,,43.034302,-89.447388\r\nThe Pink Poodle,Secondhand,\"Home Decor, Housewares\",\"6676 Odana Rd. Madison, WI 53719\",\"The Pink Poodle is an upscale consignment boutique on the West Side of Madison, WI. They accept clothing on a seasonal basis. \",https://www.thepinkpoodleresale.com/,(608) 276-7467,43.056131,-89.495599\r\nUnderground Meats,Bulk/Package-Free,Grocery,\"1133 E. Wilson St Madison, WI, United States, Wisconsin 53703\",Underground Meats is a butcher that partners with local farmers who prioritize animal welfare and sustainable practices. Bring your own container for package-free charcuterie meats! Online business with local pickup option.,https://undergroundmeats.com/,(608) 251-6171,43.083359,-89.365438\r\nUpshift Swap Shop,Secondhand,Clothing,\"826 East Johnson St, Madison, WI 53703\",\"A clothing exchange is an opportunity for everyone to shop for stylish, gently used garments on the sustainable market. Bring donations, pay a cover charge, and take home as many items as you can fit in your bag(s). See website for details on accepted clothing and prices (10/2025)\",https://www.upshiftswapshop.com/,,43.083996,-89.377388\r\nvomFASS,Bulk/Package-Free,Grocery,\"3248 University Ave, Madison, WI 53705\",\"vomFass offers oils, vinegars, and spirits in bulk.\",https://vomfassmadison-universityave.com/,(608) 204-0300,43.07568,-89.44301\r\nWilly Street Co-op—East,Bulk/Package-Free,\"Tea & Herbs, Cleaning Supplies, Personal Care, Grocery\",\"1221 Williamson St, Madison, WI 53703\",\"Willy Street Co-op is a cooperative grocery store owned by customers. The co-op sells many groceries in bulk, including rice, beans, pastas, flours, nuts, chocolate-covered almonds, candied ginger, chocolate clusters, herbs, spices, olive oil, honey, and more. Many items are certified organic and locally sourced whenever possible. \",https://www.willystreet.coop/,(608) 251-6776,43.083723,-89.362859\r\nWilly Street Co-op—North,Bulk/Package-Free,\"Tea & Herbs, Cleaning Supplies, Personal Care, Grocery\",\"2817 N Sherman Ave, Madison, WI 53704\",\"Willy Street Co-op is a cooperative grocery store owned by customers. The co-op sells many groceries in bulk, including rice, beans, pastas, flours, nuts, chocolate-covered almonds, candied ginger, chocolate clusters, herbs, spices, olive oil, honey, and more. Many items are certified organic and locally sourced whenever possible. \",https://www.willystreet.coop/,(608) 471-4422,43.127767,-89.362759\r\nWilly Street Co-op—West,Bulk/Package-Free,\"Tea & Herbs, Cleaning Supplies, Personal Care, Grocery\",\"6825 University Ave, Middleton, WI 53562\",\"Willy Street Co-op is a cooperative grocery store owned by customers. The co-op sells many groceries in bulk, including rice, beans, pastas, flours, nuts, chocolate-covered almonds, candied ginger, chocolate clusters, herbs, spices, olive oil, honey, and more. Many items are certified organic and locally sourced whenever possible. \",https://www.willystreet.coop/,(608) 284-7800,43.09644,-89.500308\r\nWilly Street Treasure Shop,Secondhand,\"Home Decor, Housewares\",\"1236 Williamson St, Madison, WI 53703\",\"Willy Street Treasure Shop is a vibrant and eclectic haven for those in search of unique home goods, gifts, and secondhand treasures.\",https://www.instagram.com/explore/locations/108438270564243/willy-street-treasure-shop/,,43.084209,-89.363435\r\nSandhill Goods,Secondhand,\"Clothing, Housewares\",2518 E Johnson Street,\"Sandhill Goods brings new life to secondhand modern and vintage clothing and home goods by rehoming them with people who value shopping slowly, intentionally, and sustainably. We know that high-quality pieces that will last a lifetime are already out there waiting to be rediscovered. We donate 20% of profits each month to organizations that are doing critical social justice work in our community and across the United States. \",https://shopsandhill.com/,,43.102424,-89.351784\r\nArtisan Dental,Hard-To-Recycle,Personal Care,\"10 North Livingston Street Suite 301, Madison, Wisconsin 53703\",\"Recycle your oral care products here!  The program is designed to help keep toothbrushes, toothpaste tubes, floss containers, deodorant container, soap wrappers and mouthwash containers out of landfills.\",https://artisandentalmadison.com/program-details/,,43.08125,-89.376102\r\nGoodwill Madison Outlet Store,Secondhand,\"Clothing, Home Decor, Housewares, Books, Accessories\",5525 Tradesmen Drive Madison Wisconsin 53718 USA,Donation and secondhand store sold by the pound. Dig through bins of items and come away with major savings! Offers home pickup donations for a fee. ,https://goodwillscwi.org/locations/madison-outlet-store/,(608) 820-1270,43.038557,-89.284798\r\nGood Style Shop,Secondhand,\"Clothing, Accessories\",\"817 E Johnson St Madison, WI 53703\",\"The longest-running independent vintage clothing shop in Madison.Selection includes men's vintage and women's vintage fashion from the 1930-1990s, throwback UW apparel, and on-trend vintage accessories in a boutique setting. Contact if interested in selling items, including estate liquidations. \",https://goodstyleshop.com/,(608) 441-1323,43.083516,-89.377214\r\nPlato's Closet Madison East,Secondhand,\"Clothing, Accessories\",\"1601 Thierer Rd. Madison, WI 53704\",Plato's buys and sells gently used clothing for tweens and young adults. Offers a huge selection of trendy styles. No appointment needed to sell items. ,https://platoscloset.com/locations/madison-wi-east/,(608) 241-9759,43.122131,-89.310697\r\nPlato's Closet Madison West,Secondhand,\"Clothing, Accessories\",\"7968 Tree Ln Madison, WI 53717\",Plato's buys and sells gently used clothing for tweens and young adults. Offers a huge selection of trendy styles. No appointment needed to sell items. ,https://platoscloset.com/locations/madison-wi-west/,(608) 662-7410,43.061476,-89.520875\r\nRagstock - State Street,Secondhand,Clothing,\"329 State St. Madison, Wisconsin 53703,\",Retail store selling both new and vintage or recycled clothing,https://ragstock.com/pages/stores/madison-wi-state-street,(608) 251-3419,43.0745907,-89.3911429\r\nRetro Revolution ,Secondhand,\"Home Decor, Housewares, Furniture, Collectible, Accessories\",\"3225 E Washington Ave, Ste B, Madison, WI 53704\",\"Curated vintage store filled with affordable and fun finds. Featuring, antiques, collectibles, jewelry, retro home decor, lighting, records, vinyls, and more. \",https://www.facebook.com/RetroRevolutionMadison/,(608) 467-6012,43.1098483,-89.3338635\r\nSt. Vincent de Paul Society - Waunakee,Secondhand,\"Clothing, Furniture, Home Decor, Housewares, Books, Accessories\",\"213 S. Klein Drive Waunakee, WI 53597\",\"The Waunakee store has been consistently voted the best St. Vinny's around! A small but mighty thrift and donation store showcasing cute clothing for the whole family, household goods to refresh your décor, and books and games to keep your kids happy! (4/2026)\",https://svdpmadison.org/store/waunakee-store/,(608) 278-2920 x599,43.1903471,-89.4638834\r\nSt. Vincent de Paul Society - Stoughton,Secondhand,\"Clothing, Furniture, Home Decor, Housewares, Books, Accessories\",\"1509 US Highway 51 & 138 Stoughton, WI 53589\",\"St. Vinny’s Thrift Store in Stoughton features gently used goods seven days a week. Shop for clothing, jewelry, household items, and furniture in this spacious store. Features drive-through donation center\",https://svdpmadison.org/store/stoughton-store/,(608) 278-2920 x299,42.987821,-89.5443112\r\nSt. Vincent de Paul Society - Sun Prairie,Secondhand,\"Clothing, Furniture, Home Decor, Housewares, Books, Accessories\",\"1110 W. Main Street Sun Prairie, WI 53590\",\"St. Vinny’s Thrift Store in Sun Prairie has a wide array of attractively displayed furniture, clothing, accessories, toys and so much more. Features drive-through donation center. \",https://svdpmadison.org/store/sun-prairie-store/,(608) 278-2920 x799,42.987821,-89.5443112\r\nSt. Vincent de Paul Society - Odana Road,Secondhand,\"Clothing, Furniture, Home Decor, Housewares, Books, Accessories\",\"6301 Odana Road Madison, WI 53719\",\"St. Vinny’s Thrift Store on Odana Road is a staple for clothing, accessories,and an ever-changing and well-displayed array of housewares, small appliances, books, and games.Features drive through donation center\",https://svdpmadison.org/store/odana-road-store/,(608) 278-2920 x399,42.987821,-89.5443112\r\nSt. Vincent de Paul - Williamson Street,Secondhand,\"Clothing, Furniture, Home Decor, Housewares, Books, Accessories\",\"1309 Williamson Street Madison, WI 53703\",\"One of the oldest and most honored thrift stores in Madison. The recently remodeled original St. Vinny’s Thrift Store, located on “Willy Street”, is filled with furniture, music, accessories, clothes, and household goods to match any taste, and is topped with solar panels. Accepts donations on site. \",https://svdpmadison.org/store/williamson-street-store/,(608) 278-2920 x199,43.0845641,-89.3619343\r\nSt. Vincent de Paul Store - Verona,Secondhand,\"Clothing, Furniture, Home Decor, Housewares, Books, Accessories\",\"513 W. Verona Avenue Verona, WI 53593\",\"St. Vinny’s thrift store in Verona is bright, has plenty of parking, and has a great selection of treasures, including a great book selection! Features a drive-through donation area. \",https://svdpmadison.org/store/verona-store/,(608) 278-2920 x699,42.987821,-89.5443112\r\nStyle Encore Madison,Secondhand,Clothing,\"1735 Thierer Road Madison, WI 53704\",\"Thrift and consignment store featuring a curated selection of previously-owned clolthing, shoes, and accessories. \",https://www.facebook.com/StyleEncoreMadisonWI/,(608) 630-8599,43.1222967,-89.3117166\r\nRagstock- West Towne,Secondhand,Clothing,\"66 West Towne Way Madison, WI 53719\",Retail store selling both new and vintage or recycled clothing,https://ragstock.com/pages/stores/madison-wi-west-towne-mall,(608) 821-3184,43.0569401,-89.5093859\r\nGiant Jones Brewing Co.,Bulk/Package-Free,Grocery,\"931 East Main Street Entrance on, S Brearly St Ste 9, Madison, WI 53703\",Locally owned brewery selling beer in refillable growlers and returnable bottles.,https://giant-jones-brewing.square.site/,(608) 620-5172,43.082711,-89.370468\r\n";
(function () {
  "use strict";

  // The Shopify section-html shim only provides an empty
  // <div id="zero-waste-map"> and this script tag, so the widget injects its
  // own markup and stylesheets at runtime instead of relying on markup that
  // used to be authored directly in the section's HTML.
  var CONTAINER_MARKUP = `
      <div class="container">
        <div class="header">
          <h1>Zero Waste Resource Map</h1>
          <p>Discover waste reduction resources across Dane County</p>
        </div>

        <div class="controls">
          <input
            type="text"
            id="searchInput"
            class="filter-input"
            placeholder="Search resources by name, description, or category..."
          />

          <div class="filter-bar">
            <button
              type="button"
              id="filterToggle"
              class="filter-toggle"
              aria-expanded="false"
              aria-controls="filterPanel"
            >
              <span class="filter-toggle-label">Filters</span>
              <span class="filter-toggle-count" id="filterCount" hidden></span>
              <span class="filter-toggle-caret" aria-hidden="true">▾</span>
            </button>

            <!-- Whatever filter is in use, restated as a chip that clears it,
                 for when the panel below is folded shut over it. -->
            <div class="active-filters" id="activeFilters" hidden></div>
          </div>

          <div class="filter-panel" id="filterPanel" hidden>
            <div class="filter-group">
              <span class="filter-group-label" id="categoryFilterLabel">
                Filter by Category:
              </span>
              <div
                class="tag-filter-row"
                role="group"
                aria-labelledby="categoryFilterLabel"
              >
                <button class="tag-filter active" data-tag="all">
                  All Resources
                </button>
                <button class="tag-filter zw-icon" data-tag="Bulk/Package-Free">
                  Bulk/Package-Free
                </button>
                <button class="tag-filter zw-icon" data-tag="Repair">
                  Repair
                </button>
                <button class="tag-filter zw-icon" data-tag="Farmer's Market">
                  Farmer's Market
                </button>
                <button class="tag-filter zw-icon" data-tag="Secondhand">
                  Secondhand
                </button>
                <button class="tag-filter zw-icon" data-tag="Compost">
                  Compost
                </button>
                <button class="tag-filter zw-icon" data-tag="Hard-To-Recycle">
                  Hard-To-Recycle
                </button>
              </div>
            </div>
            <div class="filter-group" id="subcategoryFilters" hidden>
              <span class="filter-group-label" id="subcategoryFilterLabel">
                Filter by Subcategory:
              </span>
              <div
                id="subcategoryButtons"
                class="subcategory-row"
                role="group"
                aria-labelledby="subcategoryFilterLabel"
              ></div>
            </div>
          </div>

          <div class="control-group">
            <button id="toggleView" class="view-toggle">
              📋 Switch to List View
            </button>
          </div>
        </div>

        <div class="map-layout">
          <div class="location-list" id="locationList">
            <!-- Map view locations will be populated here -->
          </div>

          <div class="map-container">
            <div id="map"></div>
            <div id="loading" class="loading">
              <div class="spinner"></div>
              <p>Loading locations...</p>
            </div>
            <div
              id="mapGestureHint"
              class="map-gesture-hint"
              role="status"
              aria-live="polite"
            >
              <div class="map-gesture-hint-card">
                <span class="map-gesture-hint-icon" aria-hidden="true">✌️</span>
                <span>Use two fingers to move the map</span>
              </div>
            </div>
          </div>
        </div>

        <div class="list-view" id="listView">
          <!-- Category-based list view will be populated here -->
        </div>
      </div>
  `;

  var LEAFLET_CSS_URL =
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css";

  // Configuration
  const CONFIG = {
    DEFAULT_CENTER: [43.0731, -89.4012], // Madison, WI [lat, lng]
    DEFAULT_ZOOM: 10,
    // Every location is in and around Dane County, so a fitted view outside
    // this range means the fit was computed against a bad container size
    // rather than a genuinely spread-out set of markers.
    MIN_FIT_ZOOM: 8,
    MAX_FIT_ZOOM: 15,
    // How far a finger travels before it counts as a drag rather than a tap,
    // so tapping a marker still opens its popup without the gesture hint.
    DRAG_THRESHOLD_PX: 8,
    // How long the gesture hint lingers after the last finger lifts.
    HINT_LINGER_MS: 1500,
  };

  let resourceMap;
  let resourceMarkers = [];
  let resourceLocations = [];
  let resourceCurrentFilter = "all";
  let resourceCurrentSubcategory = "all";
  let resourceCurrentView = "map"; // 'map' or 'list'
  let resourceFiltersExpanded = false; // whether the filter panel is open
  let resourceFitBounds = null; // bounds the current marker set should fit to
  let resourceHasFitted = false; // whether that fit ran against a laid-out map
  let gestureTouchStart = null; // where a one-finger touch on the map began
  let gestureHintTimer = null; // pending hide of the two-finger hint

  // Each category's colour and emoji come from public/theme.css, which
  // build.sh bundles into this widget's stylesheet: an element tagged
  // `data-category="<name>"` picks up that category's colour as
  // `var(--zw-category)`, and `class="zw-icon"` renders its emoji. That table
  // is shared with the location editing app, so there's no copy of it here.

  // Initialize the map with OpenStreetMap
  function initMap() {
    resourceMap = L.map("map").setView(
      CONFIG.DEFAULT_CENTER,
      CONFIG.DEFAULT_ZOOM,
    );

    // Add OpenStreetMap tiles
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 18,
    }).addTo(resourceMap);

    observeMapSize();
    enableCooperativeGestures();
    loadEmbeddedLocations();
  }

  // Leaflet pans on any one-finger drag, and the map is as wide as the page
  // it's embedded in - so on a phone there's no margin left to swipe from,
  // and a visitor scrolling down the resource guide gets caught panning the
  // map instead of moving past it. One finger is therefore left to the page
  // and the map takes two, the same bargain other embedded maps strike, with
  // an overlay that says so the moment a one-finger drag lands on the map.
  //
  // Leaflet's one-finger pan is the `dragging` handler, while its two-finger
  // handler (`touchZoom`) does both the pinch and the pan that goes with it -
  // so dropping `dragging` leaves two-finger use of the map intact. It's
  // dropped per-touch rather than for good because `dragging` is also what
  // handles mouse drags: a mouse or trackpad, including one attached to a
  // touchscreen, keeps working exactly as before, with no need to guess from
  // the device which of the two a visitor is about to use. The listener has
  // to capture on the document to get ahead of Leaflet's own `touchstart`
  // listener on the map container, which is where a pan would otherwise
  // start.
  function enableCooperativeGestures() {
    document.addEventListener("touchstart", onMapTouchStart, true);
    document.addEventListener("touchmove", onMapTouchMove, true);
    document.addEventListener("touchend", onMapTouchEnd, true);
    document.addEventListener("touchcancel", onMapTouchCancel, true);
  }

  function isTouchOnMap(event) {
    const mapElement = document.getElementById("map");
    return !!(
      mapElement &&
      event.target instanceof Node &&
      mapElement.contains(event.target)
    );
  }

  function onMapTouchStart(event) {
    if (!isTouchOnMap(event)) return;

    if (event.touches.length > 1) {
      // Two fingers: the map is theirs, so there's nothing left to explain.
      gestureTouchStart = null;
      hideGestureHint();
      return;
    }

    if (resourceMap && resourceMap.dragging) resourceMap.dragging.disable();
    gestureTouchStart = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    };
  }

  function onMapTouchMove(event) {
    if (!gestureTouchStart || event.touches.length !== 1) return;

    const movedFar =
      Math.abs(event.touches[0].clientX - gestureTouchStart.x) >
        CONFIG.DRAG_THRESHOLD_PX ||
      Math.abs(event.touches[0].clientY - gestureTouchStart.y) >
        CONFIG.DRAG_THRESHOLD_PX;

    if (movedFar) showGestureHint();
  }

  // The browser cancels the touch the moment it takes the gesture over to
  // scroll the page, which is the same "tried to move the map with one
  // finger" a touchmove past the threshold reports - and it can get there
  // first, since it only needs its own (smaller) slop distance.
  function onMapTouchCancel(event) {
    if (gestureTouchStart) showGestureHint();
    onMapTouchEnd(event);
  }

  // Deliberately not scoped to touches on the map: a touch that started
  // there and ended elsewhere still has to give `dragging` back.
  function onMapTouchEnd(event) {
    if (event.touches.length > 0) return; // fingers still down

    gestureTouchStart = null;
    if (resourceMap && resourceMap.dragging) resourceMap.dragging.enable();
    scheduleGestureHintHide();
  }

  function showGestureHint() {
    const hint = document.getElementById("mapGestureHint");
    if (!hint) return;

    clearTimeout(gestureHintTimer);
    gestureHintTimer = null;
    hint.classList.add("is-visible");
  }

  function hideGestureHint() {
    const hint = document.getElementById("mapGestureHint");
    if (!hint) return;

    clearTimeout(gestureHintTimer);
    gestureHintTimer = null;
    hint.classList.remove("is-visible");
  }

  function scheduleGestureHintHide() {
    clearTimeout(gestureHintTimer);
    gestureHintTimer = setTimeout(hideGestureHint, CONFIG.HINT_LINGER_MS);
  }

  // Leaflet derives fitBounds() from the container's pixel size, so a fit run
  // before the map has been laid out (height 0) resolves to a scale of 0 -
  // i.e. the minimum zoom, the whole world - and then stays anchored to that
  // stale geometry once the real height arrives. That's reachable here
  // because the widget's stylesheet, which is the only thing giving #map a
  // height, is injected asynchronously and can lose the race with Leaflet's
  // script; a section the theme reveals late has the same effect. So the fit
  // is skipped while the container has no size, and observeMapSize() re-runs
  // it once the container is real.
  function fitMapToBounds() {
    if (!resourceMap || !resourceFitBounds || !resourceFitBounds.isValid()) {
      return;
    }

    const size = resourceMap.getSize();
    if (!size || size.x === 0 || size.y === 0) return;

    resourceMap.fitBounds(resourceFitBounds);
    resourceHasFitted = true;

    // Keep the fitted view within the range the data can plausibly need,
    // in case a fit still lands somewhere unreasonable.
    const zoom = resourceMap.getZoom();
    if (zoom > CONFIG.MAX_FIT_ZOOM) {
      resourceMap.setZoom(CONFIG.MAX_FIT_ZOOM);
    } else if (zoom < CONFIG.MIN_FIT_ZOOM) {
      resourceMap.setZoom(CONFIG.MIN_FIT_ZOOM);
    }
  }

  // Watch the map element so a container that gains (or changes) size after
  // the map was created gets Leaflet's cached size refreshed. A CSS-driven
  // resize fires no window resize event, which is the one thing Leaflet
  // watches on its own, so without this the map never learns its real size.
  // Only a fit that never got to run is retried, so a later reflow can't yank
  // the view back from wherever the visitor has panned to.
  function observeMapSize() {
    const mapElement = document.getElementById("map");
    if (!mapElement || typeof ResizeObserver === "undefined") return;

    const observer = new ResizeObserver(() => {
      if (!mapElement.clientWidth || !mapElement.clientHeight) return;

      resourceMap.invalidateSize();
      if (!resourceHasFitted) fitMapToBounds();
    });
    observer.observe(mapElement);
  }

  // Load location data bundled into this file at build time (see
  // build.sh), which embeds the working tree's resources/locations.csv.
  // Every row is expected to already carry a valid latitude/longitude.
  function loadEmbeddedLocations() {
    try {
      const csvText = EMBEDDED_LOCATIONS_CSV;

      console.log(
        "Raw CSV data (first 500 chars):",
        csvText.substring(0, 500),
      );

      // Parse CSV data. Records are split on newlines that aren't inside a
      // quoted field, since resources/locations.csv has multi-line
      // descriptions - a plain split("\n") would break those into
      // misaligned extra rows.
      const lines = splitCSVRecords(csvText);
      const headers = lines[0]
        .split(",")
        .map((h) => h.replace(/"/g, "").trim());

      console.log("Headers found:", headers);
      console.log("Total lines in CSV:", lines.length);

      const locations = [];
      for (let i = 1; i < lines.length; i++) {
        if (lines[i].trim()) {
          const values = parseCSVLine(lines[i]);
          console.log(`Row ${i} values:`, values);

          if (values.length >= 4) {
            // Minimum: name, category, subcategories, address
            const location = {
              name: values[0] || "",
              primaryCategory: values[1] || "",
              subcategories: parseSubcategories(values[2] || ""),
              address: values[3] || "",
              description: values[4] || "",
              website: values[5] || "",
              phone: values[6] || "",
              lat: parseFloat(values[7]), // Column H - Latitude
              lng: parseFloat(values[8]), // Column I - Longitude
              notes: values[9] || "", // Column J - Notes
            };

            console.log(`Parsed location ${i}:`, location);

            if (location.name && location.address) {
              locations.push(location);
              console.log(
                `Added location: ${location.name} at ${location.address}`,
              );
            } else {
              console.warn(`Skipped row ${i} - missing name or address:`, {
                name: location.name,
                address: location.address,
              });
            }
          } else {
            console.warn(
              `Row ${i} has insufficient columns (${values.length}):`,
              values,
            );
          }
        }
      }

      console.log("Total parsed locations:", locations.length);
      resourceLocations = locations;

      if (locations.length === 0) {
        showError(
          "No valid locations found in the bundled location data. Please check resources/locations.csv.",
        );
        return;
      }

      displayLocations(resourceLocations);
      createMarkers(resourceLocations);
    } catch (error) {
      console.error("Error loading data:", error);
      showError(`Failed to load location data: ${error.message}`);
    } finally {
      document.getElementById("loading").style.display = "none";
    }
  }

  // Split CSV text into records, treating a newline as a record separator
  // only when it falls outside a quoted field
  function splitCSVRecords(text) {
    const records = [];
    let current = "";
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
      const char = text[i];

      if (char === '"') {
        inQuotes = !inQuotes;
        current += char;
      } else if (char === "\n" && !inQuotes) {
        records.push(current);
        current = "";
      } else {
        current += char;
      }
    }
    records.push(current);

    return records;
  }

  // Simple CSV parser
  function parseCSVLine(line) {
    const result = [];
    let current = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];

      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === "," && !inQuotes) {
        result.push(current.trim());
        current = "";
      } else {
        current += char;
      }
    }

    result.push(current.trim());
    return result.map((val) => val.replace(/"/g, ""));
  }

  // Parse comma-separated subcategories
  function parseSubcategories(subcategoryString) {
    if (!subcategoryString) return [];
    return subcategoryString
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
  }

  // Create map markers with Leaflet
  function createMarkers(locations) {
    // Clear existing markers
    resourceMarkers.forEach((marker) => resourceMap.removeLayer(marker));
    resourceMarkers = [];

    locations.forEach((location, index) => {
      // The marker's colour and emoji come from its category (see theme.css).
      const customIcon = L.divIcon({
        html: `<div class="map-marker zw-icon" data-category="${location.primaryCategory}"></div>`,
        className: "custom-marker",
        iconSize: [35, 35],
        iconAnchor: [17.5, 17.5],
      });

      const marker = L.marker([location.lat, location.lng], {
        icon: customIcon,
      }).addTo(resourceMap);

      marker.on("click", () => {
        selectLocation(index);
      });

      resourceMarkers.push(marker);
    });

    // Fit map to show all markers
    resourceFitBounds = null;
    resourceHasFitted = false;

    if (resourceMarkers.length > 0) {
      const group = new L.featureGroup(resourceMarkers);
      resourceFitBounds = group.getBounds().pad(0.1);
      fitMapToBounds();
    }
  }

  // Display locations in the list
  function displayLocations(locations) {
    const listContainer = document.getElementById("locationList");
    listContainer.innerHTML = "";

    if (locations.length === 0) {
      listContainer.innerHTML =
        '<p class="empty-message">No zero waste resources found.</p>';
      return;
    }

    locations.forEach((location, index) => {
      const locationItem = document.createElement("div");
      locationItem.className = "location-item";
      locationItem.setAttribute("data-index", index);

      locationItem.innerHTML = `
                <div class="location-name">${location.name}</div>
                ${location.primaryCategory ? `<div class="location-category zw-icon" data-category="${location.primaryCategory}">${location.primaryCategory}</div>` : ""}
                ${location.subcategories.length > 0 ? `<div class="location-subcategories">${location.subcategories.map((sub) => `<span class="subcategory-chip">${sub}</span>`).join("")}</div>` : ""}
                <div class="location-address">${location.address}</div>
                ${location.phone ? `<div class="location-phone">📞 ${location.phone}</div>` : ""}
                ${location.description ? `<div class="location-description">${location.description}</div>` : ""}
                ${location.website ? `<div class="location-website"><a href="${location.website}" target="_blank">Visit Website</a></div>` : ""}
            `;

      locationItem.addEventListener("click", () => {
        resourceMap.setView([location.lat, location.lng], 15);
        selectLocation(index);
      });

      listContainer.appendChild(locationItem);
    });
  }

  // Selecting a location - whether by clicking its marker or its list entry -
  // highlights both the list item (scrolling it into view) and the marker,
  // in place of the map previously opening a separate text popup.
  function selectLocation(index) {
    highlightLocationItem(index);
    highlightMarker(index);
  }

  // Highlight location item
  function highlightLocationItem(index) {
    document.querySelectorAll(".location-item").forEach((item) => {
      item.classList.remove("selected");
    });

    const targetItem = document.querySelector(`[data-index="${index}"]`);
    if (targetItem) {
      targetItem.classList.add("selected");
      targetItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  // Highlight the marker matching the selected location. Leaflet's
  // getElement() returns the marker's rendered icon node - the div this
  // widget passed as divIcon html sits inside it - so the "selected" class
  // lands on that wrapper and the CSS targets the icon through it.
  function highlightMarker(index) {
    resourceMarkers.forEach((marker) => {
      const element = marker.getElement();
      if (element) element.classList.remove("selected");
    });

    const targetMarker = resourceMarkers[index];
    const targetElement = targetMarker && targetMarker.getElement();
    if (targetElement) targetElement.classList.add("selected");
  }

  // Search and filter functionality
  function filterLocations() {
    const searchTerm = document
      .getElementById("searchInput")
      .value.toLowerCase();
    let filteredLocations = resourceLocations.filter(
      (location) =>
        location.name.toLowerCase().includes(searchTerm) ||
        location.primaryCategory.toLowerCase().includes(searchTerm) ||
        location.subcategories.some((sub) =>
          sub.toLowerCase().includes(searchTerm),
        ) ||
        location.address.toLowerCase().includes(searchTerm) ||
        location.description.toLowerCase().includes(searchTerm) ||
        location.notes.toLowerCase().includes(searchTerm),
    );

    // Apply category filter
    if (resourceCurrentFilter !== "all") {
      filteredLocations = filteredLocations.filter(
        (location) => location.primaryCategory === resourceCurrentFilter,
      );
    }

    // Apply subcategory filter
    if (resourceCurrentSubcategory !== "all") {
      filteredLocations = filteredLocations.filter((location) =>
        location.subcategories.includes(resourceCurrentSubcategory),
      );
    }

    if (resourceCurrentView === "map") {
      displayLocations(filteredLocations);
      createMarkers(filteredLocations);
    } else {
      displayListView();
    }
  }

  // The seven category pills plus a subcategory row underneath them cost more
  // vertical space than the map itself on a phone, and most visitors never
  // touch them - so they start folded away behind one button beside the search
  // box, and whatever filter is in use is summarised as a chip on that row so
  // a folded panel can't hide the reason the list looks short.
  function setFiltersExpanded(expanded) {
    resourceFiltersExpanded = expanded;

    const toggle = document.getElementById("filterToggle");
    const panel = document.getElementById("filterPanel");
    if (!toggle || !panel) return;

    toggle.setAttribute("aria-expanded", String(expanded));
    panel.hidden = !expanded;
    // The chips restate what the open panel already shows highlighted, so
    // they're only worth their row while it's shut.
    renderActiveFilters();
  }

  function activeFilterChips() {
    const chips = [];

    if (resourceCurrentFilter !== "all") {
      chips.push({ scope: "category", value: resourceCurrentFilter });
    }
    if (resourceCurrentSubcategory !== "all") {
      chips.push({ scope: "subcategory", value: resourceCurrentSubcategory });
    }

    return chips;
  }

  // Each chip clears the filter it names, so the one thing a visitor wants
  // from a filter they can see the effects of doesn't cost them a trip back
  // into the panel.
  function renderActiveFilters() {
    const summary = document.getElementById("activeFilters");
    const count = document.getElementById("filterCount");
    const toggle = document.getElementById("filterToggle");
    if (!summary || !count || !toggle) return;

    const chips = activeFilterChips();

    summary.innerHTML = chips
      .map(
        (chip) =>
          `<button type="button" class="filter-chip" data-clear="${chip.scope}"${
            chip.scope === "category" ? ` data-category="${chip.value}"` : ""
          } aria-label="Clear ${chip.scope} filter: ${chip.value}">
             <span class="filter-chip-label${chip.scope === "category" ? " zw-icon" : ""}">${chip.value}</span>
             <span class="filter-chip-remove" aria-hidden="true">✕</span>
           </button>`,
      )
      .join("");
    summary.hidden = resourceFiltersExpanded || chips.length === 0;

    count.textContent = String(chips.length);
    count.hidden = chips.length === 0;
    toggle.classList.toggle("has-filters", chips.length > 0);
  }

  function clearFilter(scope) {
    if (scope === "category") {
      setTagFilter("all");
    } else {
      setSubcategoryFilter("all");
    }
  }

  // Category filter functionality
  function setTagFilter(category) {
    resourceCurrentFilter = category;
    resourceCurrentSubcategory = "all"; // Reset subcategory when changing main category

    // Update button states
    document
      .querySelectorAll(".tag-filter:not(.subcategory)")
      .forEach((btn) => {
        btn.classList.remove("active");
        if (btn.dataset.tag === category) {
          btn.classList.add("active");
        }
      });

    // Show/hide subcategory filters
    updateSubcategoryFilters(category);
    renderActiveFilters();
    filterLocations();
  }

  // Update subcategory filter buttons
  function updateSubcategoryFilters(category) {
    const subcategoryDiv = document.getElementById("subcategoryFilters");
    const buttonsDiv = document.getElementById("subcategoryButtons");

    if (category === "all") {
      subcategoryDiv.hidden = true;
      return;
    }

    // Get unique subcategories for this category
    const subcategories = new Set();
    resourceLocations.forEach((location) => {
      const locationCategory = (location.primaryCategory || "").trim();
      const filterCategory = category.trim();

      if (locationCategory.toLowerCase() === filterCategory.toLowerCase()) {
        location.subcategories.forEach((sub) => {
          if (sub && sub.trim()) {
            subcategories.add(sub.trim());
          }
        });
      }
    });

    if (subcategories.size > 0) {
      subcategoryDiv.hidden = false;
      buttonsDiv.innerHTML = `
                <button class="tag-filter subcategory active" data-subcategory="all">All ${category}</button>
                ${Array.from(subcategories)
                  .map(
                    (sub) =>
                      `<button class="tag-filter subcategory" data-subcategory="${sub}">${sub}</button>`,
                  )
                  .join("")}
            `;
    } else {
      subcategoryDiv.hidden = true;
    }
  }

  // Subcategory filter functionality
  function setSubcategoryFilter(subcategory) {
    resourceCurrentSubcategory = subcategory;

    // Update subcategory button states
    document.querySelectorAll(".tag-filter.subcategory").forEach((btn) => {
      btn.classList.remove("active");
      if (btn.dataset.subcategory === subcategory) {
        btn.classList.add("active");
      }
    });

    renderActiveFilters();
    filterLocations();
  }

  // Generate categorized list view with filtering
  function displayListView() {
    const listContainer = document.getElementById("listView");

    // Apply the same filtering logic as the map view
    const searchTerm = document
      .getElementById("searchInput")
      .value.toLowerCase();
    let filteredLocations = resourceLocations.filter(
      (location) =>
        location.name.toLowerCase().includes(searchTerm) ||
        location.primaryCategory.toLowerCase().includes(searchTerm) ||
        location.subcategories.some((sub) =>
          sub.toLowerCase().includes(searchTerm),
        ) ||
        location.address.toLowerCase().includes(searchTerm) ||
        location.description.toLowerCase().includes(searchTerm),
    );

    // Apply category filter
    if (resourceCurrentFilter !== "all") {
      filteredLocations = filteredLocations.filter(
        (location) => location.primaryCategory === resourceCurrentFilter,
      );
    }

    // Apply subcategory filter
    if (resourceCurrentSubcategory !== "all") {
      filteredLocations = filteredLocations.filter((location) =>
        location.subcategories.includes(resourceCurrentSubcategory),
      );
    }

    const categories = {};

    // Group filtered locations by category and subcategory
    filteredLocations.forEach((location) => {
      const category = location.primaryCategory || "Other";
      if (!categories[category]) {
        categories[category] = {};
      }

      location.subcategories.forEach((subcategory) => {
        if (!categories[category][subcategory]) {
          categories[category][subcategory] = [];
        }
        categories[category][subcategory].push(location);
      });

      // If no subcategories, put in "General"
      if (location.subcategories.length === 0) {
        if (!categories[category]["General"]) {
          categories[category]["General"] = [];
        }
        categories[category]["General"].push(location);
      }
    });

    // Show message if no results
    if (filteredLocations.length === 0) {
      listContainer.innerHTML =
        '<p class="empty-message">No resources match your search criteria.</p>';
      return;
    }

    // Generate HTML
    let html = "";
    Object.entries(categories).forEach(([category, subcategories]) => {
      html += `
                <div class="category-section">
                    <div class="category-header" onclick="toggleCategory('${category}')" data-category="${category}">
                        <span class="zw-icon" data-category="${category}">${category}</span>
                        <span id="toggle-${category}">▼</span>
                    </div>
                    <div class="category-content" id="content-${category}">
            `;

      Object.entries(subcategories).forEach(([subcategory, locations]) => {
        html += `
                    <div class="subcategory-group">
                        <div class="subcategory-header">${subcategory}</div>
                `;

        locations.forEach((location) => {
          html += `
                        <div class="location-item nested">
                            <div class="location-name">${location.name}</div>
                            <div class="location-address">${location.address}</div>
                            ${location.phone ? `<div class="location-phone">📞 ${location.phone}</div>` : ""}
                            ${location.description ? `<div class="location-description">${location.description}</div>` : ""}
                            ${location.website ? `<div class="location-website"><a href="${location.website}" target="_blank">Visit Website</a></div>` : ""}
                        </div>
                    `;
        });

        html += "</div>";
      });

      html += "</div></div>";
    });

    listContainer.innerHTML = html;
  }

  // Toggle category sections in list view
  function toggleCategory(category) {
    const content = document.getElementById(`content-${category}`);
    const toggle = document.getElementById(`toggle-${category}`);

    if (content.style.display === "none") {
      content.style.display = "block";
      toggle.textContent = "▼";
    } else {
      content.style.display = "none";
      toggle.textContent = "▶";
    }
  }

  // Toggle between map and list view
  function toggleView() {
    const mapContainer = document.querySelector(".map-container");
    const locationList = document.getElementById("locationList");
    const listView = document.getElementById("listView");
    const toggleButton = document.getElementById("toggleView");

    if (resourceCurrentView === "map") {
      resourceCurrentView = "list";
      mapContainer.style.display = "none";
      locationList.style.display = "none";
      listView.style.display = "block";
      toggleButton.textContent = "🗺️ Switch to Map View";
      displayListView();
    } else {
      resourceCurrentView = "map";
      mapContainer.style.display = "block";
      locationList.style.display = "block";
      listView.style.display = "none";
      toggleButton.textContent = "📋 Switch to List View";
      filterLocations();
    }
  }

  // Show error message
  function showError(message) {
    const container = document.querySelector(".container");
    const errorDiv = document.createElement("div");
    errorDiv.className = "error-message";
    errorDiv.innerHTML = `<strong>Error:</strong> ${message}`;
    container.appendChild(errorDiv);
  }

  // Wire up event listeners and kick off the map once markup is in place
  function mount() {
    const root = document.getElementById("zero-waste-map");
    if (!root) {
      console.error(
        "[zero-waste-map] #zero-waste-map container not found on the page",
      );
      return;
    }

    root.innerHTML = CONTAINER_MARKUP;

    document
      .getElementById("searchInput")
      .addEventListener("input", filterLocations);

    document
      .getElementById("filterToggle")
      .addEventListener("click", () =>
        setFiltersExpanded(!resourceFiltersExpanded),
      );

    // Category filter event listeners. The summary chips have content of their
    // own, so a click there lands on a span rather than the button - hence
    // closest() rather than the click target's own classes.
    document.addEventListener("click", function (e) {
      if (!(e.target instanceof Element)) return;

      const chip = e.target.closest(".filter-chip");
      if (chip) {
        clearFilter(chip.dataset.clear);
        return;
      }

      const filterButton = e.target.closest(".tag-filter");
      if (!filterButton) return;

      if (filterButton.classList.contains("subcategory")) {
        setSubcategoryFilter(filterButton.dataset.subcategory);
      } else {
        setTagFilter(filterButton.dataset.tag);
      }
    });

    // View toggle event listener
    document
      .getElementById("toggleView")
      .addEventListener("click", toggleView);

    // Make toggleCategory globally accessible
    window.toggleCategory = toggleCategory;

    loadMapLibrary();
  }

  // The map's height lives in the widget's stylesheet, which is fetched
  // asynchronously below - until it lands, #map is zero-height and Leaflet
  // can't size a view against it. This inline copy applies synchronously so
  // there's no window where that's true; it's deliberately a duplicate of the
  // heights in zero-waste-map.css, which is appended after it and wins.
  // Selectors match zero-waste-map.css exactly so the later <link> wins the
  // cascade tie and stays the one place these values are edited.
  var CRITICAL_CSS = `
      .map-container { height: 500px; }
      #map { width: 100%; height: 100%; }
  `;

  // Load the widget's own stylesheet, sibling to this script, plus Leaflet's
  function loadStylesheets() {
    const criticalCss = document.createElement("style");
    criticalCss.textContent = CRITICAL_CSS;
    document.head.appendChild(criticalCss);

    const ownScript = document.currentScript;
    if (ownScript && ownScript.src) {
      const cssHref = ownScript.src.replace(/\.js(\?.*)?$/, ".css$1");
      const ownCss = document.createElement("link");
      ownCss.rel = "stylesheet";
      ownCss.href = cssHref;
      document.head.appendChild(ownCss);
    }

    const leafletCss = document.createElement("link");
    leafletCss.rel = "stylesheet";
    leafletCss.href = LEAFLET_CSS_URL;
    document.head.appendChild(leafletCss);
  }

  // Load Leaflet library and initialize
  function loadMapLibrary() {
    const script = document.createElement("script");
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js";
    script.onload = initMap;
    document.head.appendChild(script);
  }

  loadStylesheets();
  mount();
})();
